module.exports = __webpack_public_path__ + "img/br-round.81de4580.svg";